import {
  Button,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  Stack,
} from "@mui/material";
import React from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import styled from "styled-components";
import CommonDialog from "app/components/common/CommonDialog";
import { changeTestingSchoolStatus } from "app/services/org/crm/crm.service";

const ChangetestingSchoolStatus = ({
  open = false,
  onClose = () => {},
  refetch = () => {},
  schoolDocId,
  status,
}) => {
  const { mutate: changeTestingSchoolStatusMutate } = useMutation(
    changeTestingSchoolStatus,
    {
      onSuccess: (success) => {
        refetch();
        onClose();
        toast.success(success?.data?.message);
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message);
      },
    },
  );

  function changeStatus(x) {
    changeTestingSchoolStatusMutate({
      schoolDocId: schoolDocId,
      testingSchool: x,
    });
  }
  return (
    <CommonDialog
      open={open}
      onClose={onClose}
      title="School Type Dialog"
      minWidth="250px"
    >
      <DialogWrapper>
        <DialogContent sx={{ border: "0" }}>
          <Stack
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "22px ",
              }}
            >
              Are you sure you want to change the type of School to{" "}
              <span
                style={{
                  color: "#ff0d02",
                }}
              >
                {status === true ? "Not Testing" : "Testing"}
              </span>
              ?
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Box width="100%">
            <Stack
              direction={"row"}
              spacing={2}
              sx={{
                justifyContent: "space-between",
                px: 5,
                marginBottom: "35px",
              }}
            >
              <Button
                className="dialog-button"
                variant="outlined"
                color="error"
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                className="dialog-button"
                variant="contained"
                color="success"
                onClick={() => changeStatus(!status)}
              >
                Yes
              </Button>
            </Stack>
          </Box>
        </DialogActions>
      </DialogWrapper>
    </CommonDialog>
  );
};

export default ChangetestingSchoolStatus;

const DialogWrapper = styled.div`
  // Dilog Box Css
  .dialog-button {
    width: 170px;
    height: 50px;
    flex-shrink: 0;
    border-radius: 10px;

    box-sizing: border-box;
    text-align: center;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
  }
  .payment-active {
    width: 170px;
    height: 50px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid rgba(41, 219, 91, 0.4);
    background: rgba(41, 219, 91, 0.1);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    color: #00ac30;
  }
  .payment-inactive {
    width: 170px;
    height: 50px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid rgba(219, 41, 41, 0.4);
    background: rgba(219, 41, 41, 0.1);
    color: #ff0d02;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
  }
`;
